/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import {
  useCallback,
  useEffect,
  type Dispatch,
  type FormEvent,
  type SetStateAction
} from "react";

import { useSearch } from "@/hooks";

import type { BreedListItem } from "../breeds.types";

interface UseSearchBreedProps {
  breeds: BreedListItem[];
  updateFilters: Dispatch<SetStateAction<BreedListItem[]>>;
}

export const useSearchBreed = ({
  breeds,
  updateFilters
}: UseSearchBreedProps) => {
  const {
    value,
    suggestions,
    selectedIndex,
    inputRef,
    suggestionContainerRef,
    handleInputChange,
    handleOnFocus,
    handleClearInput,
    handleKeyDown,
    handleClickSuggestion
  } = useSearch<BreedListItem>({
    items: breeds,
    getLabel: (breed) => breed.name
  });

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!value.trim()) return;

    if (value) {
      const filteredBreed = breeds.filter((breed) =>
        breed.name.toLowerCase().startsWith(value.toLowerCase())
      );

      updateFilters(filteredBreed);
    }
  };

  const resetSearch = useCallback(() => {
    updateFilters(breeds);
  }, [breeds, updateFilters]);

  useEffect(() => {
    if (!value) {
      resetSearch();
    }
  }, [value]);

  return {
    inputRef,
    value,
    suggestions,
    suggestionContainerRef,
    selectedIndex,
    handleSubmit,
    handleInputChange,
    handleOnFocus,
    handleKeyDown,
    handleClickSuggestion,
    handleClearInput
  };
};
